// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content .btn-warp[data-v-33296cb5] {\n  display: flex;\n  justify-content: space-around;\n}\n.btn-list[data-v-33296cb5] {\n  margin: 0 10px;\n}\n[data-v-33296cb5] .el-table {\n  height: calc(100% - 120px) !important;\n  overflow: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
